<template>
    <div>
        <card-header title="Course Enrollments" icon="fa-chalkboard-teacher"/>

        <card-toolbar v-if="currentUser.isSuper">
            <button @click="$openCard('new-classic-enrollment', {userId: props.userId}, card)"><i class="far fa-plus"></i>New Classic Enrollment</button>
        </card-toolbar>

        <card-body>
            <card-list>
                <subheader-list-item title="Classic Enrollments" icon="fa-chalkboard-teacher" :badge="classicEnrollments.length" />

                <course-classic-enrollment-tile
                    :enrollment="e"
                    v-for="e in classicEnrollments"
                    :card="card"
                    :active="(child && child.definition.component === 'edit-classic-enrollment' && e.id === parseInt(child.props.enrollId))"
                    @click="adminOpenCard('edit-classic-enrollment', e.id)"
                />

                <subheader-list-item title="New Enrollments" icon="fa-chalkboard-teacher" :badge="enrollments.length"/>

                <course-enrollment-tile
                    :enrollment="e"
                    v-for="e in enrollments"
                    :card="card"
                    :active="(child && child.definition.component === 'edit-enrollment' && e.id === parseInt(child.props.enrollId))"
                    @click="adminOpenCard('edit-enrollment', e.id)"
                />
            </card-list>
        </card-body>
    </div>
</template>


<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import {client as http} from '@/http_client';
    import CourseEnrollmentTile from "../../components/tiles/CourseEnrollmentTile";
    import async from "async";
    import CourseClassicEnrollmentTile from "../../components/tiles/CourseClassicEnrollmentTile";
    import CardToolbar from "../../TIER/components/CardToolbar";

    import { mapGetters } from "vuex";

    export default {
        components: {CardToolbar, CourseClassicEnrollmentTile, CourseEnrollmentTile, CardHeader, CardBody, CardList, SubheaderListItem},
        props: ['card', 'props', 'child'],

        data() {
            return {
                enrollments: {},
                classicEnrollments: {}
            }
        },
        computed: {
            ...mapGetters(['currentUser']),
        },
        methods: {
            adminOpenCard(card, enrollId) {
                if (this.currentUser.isSuper)
                    this.$openCard(card, {userId: this.props.userId, enrollId}, this.card);
            },
            loadEnrollments: function(force) {
                this.$emit('loading', true);

                async.parallel([
                    (cb) => {
                        http.get('enrollments/new/' + this.props.userId, {force}).then(response => {
                            this.enrollments = response.data;
                            cb();
                        });
                    },
                    (cb) => {
                        http.get('enrollments/classic/' + this.props.userId, {force}).then(response => {
                            this.classicEnrollments = response.data;
                            cb();
                        });
                    }
                ], err => {
                    this.$emit('loading', false);

                });
            },
            reload: function() {
                this.loadEnrollments(true);
            }
        },
        mounted: function() {
            this.loadEnrollments();
        }
    }
</script>

<style lang="scss" scoped>

</style>
